module.exports = require("./fur.d.ts");